<template>
  <div>
    <b-modal :title="getTitleModal" modal-class="modal-primary" hide-footer @hidden="$emit('close')"
      no-close-on-backdrop no-close-on-esc v-model="show">
      <!-- <b-alert v-if="existePeriodo" variant="warning" show class="p-1 mb-2">
        Ya existen Bonos para el periodo
        <strong>{{ form.anio }} - {{ form.periodo }}</strong>.
      </b-alert> -->

      <ValidationObserver ref="ref-generar-bonos">
        <b-row>
          <b-col lg="6" md="6" sm="12">
            <ValidationProvider v-slot="{ errors }" rules="required" name="anio">
              <b-form-group :state="errors[0] ? false : null">
                <label class="form-label">
                  Año <span class="text-danger">(*)</span>
                </label>
                <v-select v-model="form.anio" :options="anios" label="name" :reduce="(anio) => anio.id"
                  placeholder="Seleccione ..." />
              </b-form-group>
            </ValidationProvider>
          </b-col>

          <b-col lg="6" md="6" sm="12">
            <ValidationProvider v-slot="{ errors }" rules="required" name="periodo">
              <b-form-group :state="errors[0] ? false : null">
                <label class="form-label">
                  Periodo <span class="text-danger">(*)</span>
                </label>
                <v-select v-model="form.periodo" :options="periodos" placeholder="Seleccione ..." />
              </b-form-group>
            </ValidationProvider>
          </b-col>
        </b-row>
      </ValidationObserver>

      <div class="d-flex justify-content-end gap-x-3">
        <b-button variant="outline-primary" @click="generarBonos">
          <!-- :disabled="existePeriodo" -->
          GENERAR
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import { mapGetters } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import CtsService from "@/views/rrhh/views/payroll/components/cts/service/cts.service.js";
import BonoService from "@/views/rrhh/views/payroll/components/bonos/service/bono.service.js";
import { getMonthByNumber2 } from "@/helpers/helpers.js";
import moment from "moment-timezone";

export default {
  components: {
    flatPickr,
  },
  props: {
    modalData: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      periodos: [],
      show: true,
      form: {
        periodo: null,
        anio: null,
      },
      periodosExistentes: [],
    };
  },
  mounted() {
    // periodos debe contener los meses del anio hasta el mes actual
    const year = new Date().getFullYear();
    const month = new Date().getMonth();

    for (let m = 0; m < 12; m++) {
      this.periodos.push(this.getMonthByNumber2(m + 1));
    }

    // this.getPeriodos();
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    getTitleModal() {
      return "GENERAR BONOS";
    },
    anios() {
      const years = [];

      const anioInicio = 2025;
      const anioActual = moment().year();

      for (let anio = anioInicio; anio <= anioActual; anio++) {
        years.push({ id: anio, name: anio });
      }
      this.anioSeleccionado = anioActual;

      return years;
    },
    // existePeriodo() {
    //   if (!this.form.anio || !this.form.periodo) return false;
    //   return this.periodosExistentes.some(
    //     (p) =>
    //       Number(p.anio) === Number(this.form.anio) &&
    //       p.periodo.toUpperCase() === this.form.periodo.toUpperCase()
    //   );
    // },
  },
  methods: {
    getMonthByNumber2,
    async generarBonos() {
      try {
        const result = await this.$refs["ref-generar-bonos"].validate();
        if (result) {
          const confirm = await this.showConfirmSwal(
            `¿Está seguro de generar los BONOS para el periodo ${this.form.anio} - ${this.form.periodo}?`,
            "Esta acción no se puede deshacer."
          );
          if (confirm.isConfirmed) {
            this.addPreloader();
            console.log("form: ", this.form)
            // const { data } = await BonoService.generar(this.form);
            const { data } = await BonoService.generar({
              anio: this.form.anio,
              periodo: this.form.periodo
            });

            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: data.message,
                icon: "CheckCircleIcon",
                variant: "success",
                text: data.message,
              },
            });

            this.$emit("generated");
          }
        }
      } catch (error) {
      console.log("log-generar-bonos: ", error)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error",
            icon: "XCircleIcon",
            variant: "danger",
            text: error?.response?.data || error.message || error,
          },
        });
      } finally {
        this.removePreloader();
      }
    },
    // async getPeriodos() {
    //   try {
    //     const { data } = await BonoService.getPeriodos(this.operacion);
    //     this.periodosExistentes = data || [];
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
  },
};
</script>
